import Table from "../../../component/table/Table";
import tableData from "../../../utils/produzione/archivioData.json";

const Archivio = () => {
    const columns = [
        { field: "nomeDellaProduzione", headerName: "Nome della produzione", width: 1042 },
        { field: "prodotto", headerName: "Prodotto", width: 263 },
        { field: "stato", headerName: "Stato", width: 190 },
        { field: "tracciabilita", headerName: "Tracciabilità", width: 184 },
        { field: "azioni", headerName: "Azioni", width: 60, sortable: false }
    ];


    return (
        <>
            <div className="pageTemplate">
                <Table data={tableData} columns={columns} navData={"produzioni"} />
            </div>
        </>
    );
};

export default Archivio;